import { DgGridContent } from "@dasgate/uikit";
import Vue from "vue";
import Component from "vue-class-component";
import { AccreditationsLoading } from "@/ui/Profile/_components/AccreditationsLoading";

@Component({ components: { DgGridContent, AccreditationsLoading } })
export default class MyAccreditationsLoading extends Vue {}
